<template lang="html">
  <div class="modal">
    This is a modal
  </div>
</template>

<script>
export default {}
</script>

<style lang="css">
  .modal {
    width: 100px;
    height: 100px;
    border: 1px solid #ccc;
  }
</style>
